import jwt_decode from "jwt-decode";

const decodeTokenExpiry = (accessToken: string) => {
  const { exp } = jwt_decode<{ exp: number }>(accessToken);
  const ttl = exp * 1000 - Date.now();

  return { exp, ttl };
};

export default decodeTokenExpiry;
